// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Login / register. Scoped under .auth-page: these pages render outside the panel shell and
   pick up whatever global CSS the current path loaded, so they carry their own layout. */

.auth-page {
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: calc(var(--ds-space-4) + var(--ds-safe-top)) var(--ds-space-4)
    calc(var(--ds-space-4) + var(--ds-safe-bottom));
  background: var(--ds-bg);
  font-family: var(--ds-font);
  color: var(--ds-text);
  overflow-x: hidden;
}

.auth-page__card {
  width: 100%;
  max-width: 440px;
  display: flex;
  flex-direction: column;
  background: var(--ds-surface);
  border: 1px solid var(--ds-border-soft);
  border-radius: var(--ds-radius-lg);
  box-shadow: var(--ds-shadow-md);
  overflow: hidden;
}

.auth-page__brand {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--ds-space-5) var(--ds-space-4) 0;
}

.auth-page__brand img {
  width: 96px;
  height: auto;
  max-width: 100%;
}

.auth-page__body {
  padding: var(--ds-space-5) var(--ds-space-5) var(--ds-space-6);
  min-width: 0;
}

.auth-page__title {
  margin: 0 0 var(--ds-space-5);
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.25;
  text-align: center;
  color: var(--ds-text);
  overflow-wrap: anywhere;
}

.auth-page__form .ant-form-item {
  margin-bottom: var(--ds-space-4);
}

.auth-page__submit {
  margin-top: var(--ds-space-2);
  margin-bottom: 0;
}

.auth-page__switch {
  margin-top: var(--ds-space-4);
  text-align: center;
  color: var(--ds-text-2);
}

.auth-page__switch a {
  display: inline-flex;
  align-items: center;
  min-height: 40px;
  color: var(--ds-brand-strong);
  font-weight: 500;
}

@media (min-width: 768px) {
  .auth-page {
    padding: var(--ds-space-8);
  }

  .auth-page__card {
    max-width: 820px;
    flex-direction: row;
  }

  .auth-page__brand {
    flex: 0 0 42%;
    padding: var(--ds-space-8);
    background: var(--ds-surface-muted);
    border-inline-end: 1px solid var(--ds-border-soft);
  }

  .auth-page__brand img {
    width: min(220px, 100%);
  }

  .auth-page__body {
    flex: 1 1 auto;
    padding: var(--ds-space-8);
  }

  .auth-page__title {
    text-align: start;
  }
}

/* Inside the panel shell (admin/sub-admin forgot password, lock screen): no full-height page. */
.auth-page.auth-page--embedded {
  min-height: 0;
  padding: 0;
  background: transparent;
}

.auth-page__subtitle {
  margin: calc(-1 * var(--ds-space-3)) 0 var(--ds-space-5);
  color: var(--ds-text-2);
  text-align: center;
}

form.auth-page__form {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-4);
}

.auth-page__user {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--ds-space-2);
  margin-bottom: var(--ds-space-5);
}

.auth-page__user h2 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--ds-text);
}

@media (min-width: 768px) {
  .auth-page__subtitle {
    text-align: start;
  }
}

/* ── Login: split layout with a branded panel (desktop), logo + form (phones) ── */
.auth-page:has(.auth-page__card--split) {
  padding: 0;
  align-items: stretch;
  background: var(--ds-surface);
}

.auth-page .auth-page__card--split {
  width: 100%;
  max-width: none;
  flex-direction: column;
  border: 0;
  border-radius: 0;
  box-shadow: none;
}

.auth-page .auth-page__brand--hero {
  display: none;
}

.auth-page__card--split .auth-page__body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  max-width: 460px;
  margin: 0 auto;
  padding: calc(var(--ds-space-8) + var(--ds-safe-top)) var(--ds-space-5)
    calc(var(--ds-space-8) + var(--ds-safe-bottom));
}

.auth-page__mobile-logo {
  width: 168px;
  height: auto;
  margin-bottom: var(--ds-space-8);
}

.auth-page__card--split .auth-page__title {
  margin-bottom: var(--ds-space-2);
  font-family: var(--ds-font-display);
  font-size: 1.75rem;
  font-weight: 800;
  color: var(--ds-heading);
  text-align: start;
}

.auth-page__card--split .auth-page__subtitle {
  margin: 0 0 var(--ds-space-6);
  text-align: start;
}

.auth-page__card--split .auth-page__submit .ant-btn {
  height: 50px;
  font-size: 1rem;
}

@media (min-width: 992px) {
  .auth-page .auth-page__card--split {
    flex-direction: row;
    min-height: 100dvh;
  }

  .auth-page .auth-page__brand--hero {
    position: relative;
    overflow: hidden;
    display: flex;
    flex: 0 0 46%;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    margin: 16px;
    margin-inline-end: 0;
    padding: 48px;
    border: 0;
    border-radius: 28px;
    color: #fff;
    background:
      radial-gradient(90% 80% at 100% 0%, rgba(79, 179, 211, 0.55) 0%, transparent 60%),
      linear-gradient(
        150deg,
        var(--ds-brand-deep) 0%,
        var(--ds-brand-dark) 55%,
        var(--ds-brand) 100%
      );
  }

  .auth-page__brand--hero::after {
    content: "";
    position: absolute;
    inset-inline-end: -120px;
    bottom: -160px;
    width: 460px;
    height: 460px;
    border: 56px solid rgba(255, 255, 255, 0.07);
    border-radius: 96px;
    transform: rotate(45deg);
  }

  .auth-page__brand--hero img {
    width: 200px;
  }

  .auth-page__tagline {
    position: relative;
    z-index: 1;
    max-width: 420px;
    margin: 0;
    font-family: var(--ds-font-display);
    font-size: 2rem;
    font-weight: 700;
    line-height: 1.25;
    letter-spacing: -0.01em;
  }

  .auth-page__card--split .auth-page__body {
    flex: 1 1 auto;
    padding: var(--ds-space-8);
  }

  .auth-page__mobile-logo {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/normalUsers/components/login/AuthPage.css"],"names":[],"mappings":"AAAA;yFACyF;;AAEzF;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB;mDACiD;EACjD,wBAAwB;EACxB,2BAA2B;EAC3B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,uCAAuC;EACvC,kCAAkC;EAClC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,8DAA8D;EAC9D,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,0BAA0B;IAC1B,mCAAmC;IACnC,kDAAkD;EACpD;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,gGAAgG;AAChG;EACE,aAAa;EACb,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,wDAAwD;EACxD,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,mFAAmF;AACnF;EACE,UAAU;EACV,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd;mDACiD;AACnD;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,8BAA8B;IAC9B,YAAY;IACZ,oBAAoB;IACpB,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,WAAW;IACX;;;;;;;OAOG;EACL;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,wBAAwB;IACxB,cAAc;IACd,YAAY;IACZ,aAAa;IACb,4CAA4C;IAC5C,mBAAmB;IACnB,wBAAwB;EAC1B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,SAAS;IACT,mCAAmC;IACnC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* Login / register. Scoped under .auth-page: these pages render outside the panel shell and\n   pick up whatever global CSS the current path loaded, so they carry their own layout. */\n\n.auth-page {\n  min-height: 100vh;\n  min-height: 100dvh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: calc(var(--ds-space-4) + var(--ds-safe-top)) var(--ds-space-4)\n    calc(var(--ds-space-4) + var(--ds-safe-bottom));\n  background: var(--ds-bg);\n  font-family: var(--ds-font);\n  color: var(--ds-text);\n  overflow-x: hidden;\n}\n\n.auth-page__card {\n  width: 100%;\n  max-width: 440px;\n  display: flex;\n  flex-direction: column;\n  background: var(--ds-surface);\n  border: 1px solid var(--ds-border-soft);\n  border-radius: var(--ds-radius-lg);\n  box-shadow: var(--ds-shadow-md);\n  overflow: hidden;\n}\n\n.auth-page__brand {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--ds-space-5) var(--ds-space-4) 0;\n}\n\n.auth-page__brand img {\n  width: 96px;\n  height: auto;\n  max-width: 100%;\n}\n\n.auth-page__body {\n  padding: var(--ds-space-5) var(--ds-space-5) var(--ds-space-6);\n  min-width: 0;\n}\n\n.auth-page__title {\n  margin: 0 0 var(--ds-space-5);\n  font-size: 1.5rem;\n  font-weight: 700;\n  line-height: 1.25;\n  text-align: center;\n  color: var(--ds-text);\n  overflow-wrap: anywhere;\n}\n\n.auth-page__form .ant-form-item {\n  margin-bottom: var(--ds-space-4);\n}\n\n.auth-page__submit {\n  margin-top: var(--ds-space-2);\n  margin-bottom: 0;\n}\n\n.auth-page__switch {\n  margin-top: var(--ds-space-4);\n  text-align: center;\n  color: var(--ds-text-2);\n}\n\n.auth-page__switch a {\n  display: inline-flex;\n  align-items: center;\n  min-height: 40px;\n  color: var(--ds-brand-strong);\n  font-weight: 500;\n}\n\n@media (min-width: 768px) {\n  .auth-page {\n    padding: var(--ds-space-8);\n  }\n\n  .auth-page__card {\n    max-width: 820px;\n    flex-direction: row;\n  }\n\n  .auth-page__brand {\n    flex: 0 0 42%;\n    padding: var(--ds-space-8);\n    background: var(--ds-surface-muted);\n    border-inline-end: 1px solid var(--ds-border-soft);\n  }\n\n  .auth-page__brand img {\n    width: min(220px, 100%);\n  }\n\n  .auth-page__body {\n    flex: 1 1 auto;\n    padding: var(--ds-space-8);\n  }\n\n  .auth-page__title {\n    text-align: start;\n  }\n}\n\n/* Inside the panel shell (admin/sub-admin forgot password, lock screen): no full-height page. */\n.auth-page.auth-page--embedded {\n  min-height: 0;\n  padding: 0;\n  background: transparent;\n}\n\n.auth-page__subtitle {\n  margin: calc(-1 * var(--ds-space-3)) 0 var(--ds-space-5);\n  color: var(--ds-text-2);\n  text-align: center;\n}\n\nform.auth-page__form {\n  display: flex;\n  flex-direction: column;\n  gap: var(--ds-space-4);\n}\n\n.auth-page__user {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--ds-space-2);\n  margin-bottom: var(--ds-space-5);\n}\n\n.auth-page__user h2 {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: var(--ds-text);\n}\n\n@media (min-width: 768px) {\n  .auth-page__subtitle {\n    text-align: start;\n  }\n}\n\n/* ── Login: split layout with a branded panel (desktop), logo + form (phones) ── */\n.auth-page:has(.auth-page__card--split) {\n  padding: 0;\n  align-items: stretch;\n  background: var(--ds-surface);\n}\n\n.auth-page .auth-page__card--split {\n  width: 100%;\n  max-width: none;\n  flex-direction: column;\n  border: 0;\n  border-radius: 0;\n  box-shadow: none;\n}\n\n.auth-page .auth-page__brand--hero {\n  display: none;\n}\n\n.auth-page__card--split .auth-page__body {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  width: 100%;\n  max-width: 460px;\n  margin: 0 auto;\n  padding: calc(var(--ds-space-8) + var(--ds-safe-top)) var(--ds-space-5)\n    calc(var(--ds-space-8) + var(--ds-safe-bottom));\n}\n\n.auth-page__mobile-logo {\n  width: 168px;\n  height: auto;\n  margin-bottom: var(--ds-space-8);\n}\n\n.auth-page__card--split .auth-page__title {\n  margin-bottom: var(--ds-space-2);\n  font-family: var(--ds-font-display);\n  font-size: 1.75rem;\n  font-weight: 800;\n  color: var(--ds-heading);\n  text-align: start;\n}\n\n.auth-page__card--split .auth-page__subtitle {\n  margin: 0 0 var(--ds-space-6);\n  text-align: start;\n}\n\n.auth-page__card--split .auth-page__submit .ant-btn {\n  height: 50px;\n  font-size: 1rem;\n}\n\n@media (min-width: 992px) {\n  .auth-page .auth-page__card--split {\n    flex-direction: row;\n    min-height: 100dvh;\n  }\n\n  .auth-page .auth-page__brand--hero {\n    position: relative;\n    overflow: hidden;\n    display: flex;\n    flex: 0 0 46%;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: space-between;\n    margin: 16px;\n    margin-inline-end: 0;\n    padding: 48px;\n    border: 0;\n    border-radius: 28px;\n    color: #fff;\n    background:\n      radial-gradient(90% 80% at 100% 0%, rgba(79, 179, 211, 0.55) 0%, transparent 60%),\n      linear-gradient(\n        150deg,\n        var(--ds-brand-deep) 0%,\n        var(--ds-brand-dark) 55%,\n        var(--ds-brand) 100%\n      );\n  }\n\n  .auth-page__brand--hero::after {\n    content: \"\";\n    position: absolute;\n    inset-inline-end: -120px;\n    bottom: -160px;\n    width: 460px;\n    height: 460px;\n    border: 56px solid rgba(255, 255, 255, 0.07);\n    border-radius: 96px;\n    transform: rotate(45deg);\n  }\n\n  .auth-page__brand--hero img {\n    width: 200px;\n  }\n\n  .auth-page__tagline {\n    position: relative;\n    z-index: 1;\n    max-width: 420px;\n    margin: 0;\n    font-family: var(--ds-font-display);\n    font-size: 2rem;\n    font-weight: 700;\n    line-height: 1.25;\n    letter-spacing: -0.01em;\n  }\n\n  .auth-page__card--split .auth-page__body {\n    flex: 1 1 auto;\n    padding: var(--ds-space-8);\n  }\n\n  .auth-page__mobile-logo {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
